import React from 'react'
import RouteContainer from "../../../common/styles/RouteContainer";
import useBookRecommenders from "./useBookRecommenders";
import InfiniteScroll from 'react-infinite-scroll-component';
import RouteTitle from "../../../common/RouteTitle/RouteTitle";
import BooksitoutIcon from "../../../config/BooksitoutIcon";
import RouteTitleConfig from "../../../config/RouteTitleConfig";
import RowSpacer from "../../../common/styles/RowSpacer";
import BookRecommenderListRow from "./BookRecommenderListRow";
import IndexContentContainer from "../../index/IndexContentContainer";
import useHtmlTitle from "../../../common/useHtmlTitle";
import BookRecommenderListRowLoading from "./BookRecommenderListRowLoading";
import UserBookRecommendationSection from "./user/UserBookRecommendationSection";

const BookRecommendersRoute = () => {
    useHtmlTitle('책 추천 받기')

    const [isLoading, recommenders, paging] = useBookRecommenders(20)

    return (
        <RouteContainer>
            <RouteTitle
                icon={<BooksitoutIcon.recommend/>}
                title={'책 추천 받기'}
                subTitle={'다양한 분야의 지식인들이 추천한 책을 만나보세요'}
                currentKey={'recommendations'}
                buttons={RouteTitleConfig.Community}
                rightUi={undefined}
            />

            <RowSpacer size={40}/>

            <UserBookRecommendationSection />

            <RowSpacer size={40}/>

            <SectionTitle>유명인의 책 추천</SectionTitle>

            <RowSpacer size={10}/>

            {
                isLoading ?
                    Array.from({length: 10}).map((_, index) =>
                        <React.Fragment key={index}>
                            <BookRecommenderListRowLoading colorType={'card'}/>
                            <RowSpacer size={10}/>
                        </React.Fragment>
                    )
                    :
                    <InfiniteScroll
                        next={paging.fetchNext}
                        hasMore={paging.hasMore}
                        dataLength={recommenders.length}
                        className='overflow-hidden'
                        loader={
                            <IndexContentContainer backgroundColorType={'card'}>
                                <div>Loading more...</div>
                            </IndexContentContainer>
                        }
                    >
                        {
                            recommenders.map(recommender =>
                                <React.Fragment key={recommender.id}>
                                    <BookRecommenderListRow recommender={recommender} colorType={'card'}/>
                                    <RowSpacer size={5}/>
                                </React.Fragment>
                            )
                        }
                    </InfiniteScroll>
            }
            <RowSpacer size={40}/>
        </RouteContainer>
    )
}

const SectionTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <h4 style={{ fontWeight: 'bold', color: 'var(--text-color)', margin: 0, marginBottom: '15px' }}>
            {children}
        </h4>
    )
}

export default BookRecommendersRoute
